export const DOMAIN = "https://scdaily.com/";
// process.env.NODE_ENV === "development"
//   ? "http://192.168.86.200:8890/" : "https://scdaily.com/";
export const API_URL = DOMAIN + "api/";
export const GOOGLE_MAP_URL =
  "https://maps.googleapis.com/maps/api/js?key=AIzaSyAAm3Z3Oyg8giyOSaWesBV-qe3j35ow70Y&v=3.exp&libraries=geometry,drawing,places";
export const USER_ROLES = [
  {
    id: 600,
    display_name: "用戶",
  },
  {
    id: 500,
    display_name: "訂閱管理員",
  },
  {
    id: 400,
    display_name: "記者",
  },
  {
    id: 300,
    display_name: "總編",
  },
  {
    id: 200,
    display_name: "管理員",
  },
  {
    id: 100,
    display_name: "總管理員",
  },
];
export const GENDERS = ["Female", "Male"];
export const EVENT_STATUSES = [
  "Not Finished",
  "Canceled",
  "Enroute",
  "Completed",
  "Missed",
];
export const SCHEDULE_STATUSES = ["Pending", "Approved", "Rejected"];
export const SCHEDULE_STATUS_COLORS = ["warning", "success", "danger"];

export const YELLOW_CATEGORIES = [
  {
    id: 86,
    parent_id: 10,
    sort: 1,
    name: "businesses",
    display_name: "商業·设备",
    category_id: 0,
    sub_categories: [
      {
        id: 87,
        parent_id: 86,
        sort: 1,
        name: "advertising_banners",
        display_name: "招牌",
        category_id: 0,
      },
      {
        id: 88,
        parent_id: 86,
        sort: 2,
        name: "graphic_design",
        display_name: "廣告設計",
        category_id: 0,
      },
      {
        id: 91,
        parent_id: 86,
        sort: 3,
        name: "utility_providers",
        display_name: "電力公司",
        category_id: 0,
      },
      {
        id: 156,
        parent_id: 86,
        sort: 4,
        name: "sports",
        display_name: "運動器材",
        category_id: 0,
      },
      {
        id: 157,
        parent_id: 86,
        sort: 5,
        name: "racks",
        display_name: "貨架",
        category_id: 0,
      },
      {
        id: 158,
        parent_id: 86,
        sort: 6,
        name: "business_real_estate",
        display_name: "生意買賣",
        category_id: 0,
      },
      {
        id: 92,
        parent_id: 86,
        sort: 7,
        name: "photography",
        display_name: "攝影&監控",
        category_id: 0,
      },
      {
        id: 89,
        parent_id: 86,
        sort: 8,
        name: "computer",
        display_name: "電腦&通訊",
        category_id: 0,
      },
      {
        id: 143,
        parent_id: 86,
        sort: 9,
        name: "network_tv",
        display_name: "網路電視",
        category_id: 0,
      },
      {
        id: 90,
        parent_id: 86,
        sort: 10,
        name: "credit_service",
        display_name: "信用卡公司",
        category_id: 0,
      },
      {
        id: 140,
        parent_id: 86,
        sort: 11,
        name: "printing",
        display_name: "印刷公司",
        category_id: 0,
      },
      {
        id: 93,
        parent_id: 86,
        sort: 12,
        name: "delivery",
        display_name: "快遞包裹",
        category_id: 0,
      },
      {
        id: 141,
        parent_id: 86,
        sort: 13,
        name: "funeral_service",
        display_name: "葬儀服務",
        category_id: 0,
      },
      {
        id: 94,
        parent_id: 86,
        sort: 14,
        name: "others_business",
        display_name: "其他",
        category_id: 0,
      },
    ],
  },
  {
    id: 18,
    parent_id: 10,
    sort: 2,
    name: "legal_service",
    display_name: "法律政府",
    category_id: 0,
    sub_categories: [
      {
        id: 19,
        parent_id: 18,
        sort: 1,
        name: "immigration_lawyers",
        display_name: "移民律師",
        category_id: 0,
      },
      {
        id: 22,
        parent_id: 18,
        sort: 2,
        name: "general_lawyers",
        display_name: "聯合律師",
        category_id: 0,
      },
      {
        id: 20,
        parent_id: 18,
        sort: 3,
        name: "custom",
        display_name: "報關行",
        category_id: 0,
      },
      {
        id: 21,
        parent_id: 18,
        sort: 4,
        name: "translation",
        display_name: "翻譯社",
        category_id: 0,
      },
      {
        id: 23,
        parent_id: 18,
        sort: 5,
        name: "consulate",
        display_name: "領事館",
        category_id: 0,
      },
    ],
  },
  {
    id: 24,
    parent_id: 10,
    sort: 3,
    name: "life",
    display_name: "生活日常",
    category_id: 0,
    sub_categories: [
      {
        id: 25,
        parent_id: 24,
        sort: 1,
        name: "hair_and_beauty",
        display_name: "美容美髮",
        category_id: 0,
      },
      {
        id: 148,
        parent_id: 24,
        sort: 1,
        name: "foodie",
        display_name: "健康食品",
        category_id: 0,
      },
      {
        id: 29,
        parent_id: 24,
        sort: 2,
        name: "supermarkets",
        display_name: "超級市場",
        category_id: 0,
      },
      {
        id: 30,
        parent_id: 24,
        sort: 3,
        name: "shopping_malls",
        display_name: "商場禮品",
        category_id: 0,
      },
      {
        id: 28,
        parent_id: 24,
        sort: 4,
        name: "furniture",
        display_name: "家具公司",
        category_id: 0,
      },
      {
        id: 128,
        parent_id: 24,
        sort: 5,
        name: "blinds",
        display_name: "窗簾/地毯",
        category_id: 0,
      },
      {
        id: 152,
        parent_id: 24,
        sort: 6,
        name: "water_filtration",
        display_name: "净水设备",
        category_id: 0,
      },
      {
        id: 132,
        parent_id: 24,
        sort: 7,
        name: "house_cleaning",
        display_name: "清潔殺蟲",
        category_id: 0,
      },
      {
        id: 31,
        parent_id: 24,
        sort: 8,
        name: "others_life",
        display_name: "其他",
        category_id: 0,
      },
    ],
  },
  {
    id: 32,
    parent_id: 10,
    sort: 4,
    name: "real_estate_n_repair",
    display_name: "地產·修理",
    category_id: 0,
    sub_categories: [
      {
        id: 33,
        parent_id: 32,
        sort: 1,
        name: "house_rentals",
        display_name: "房屋租售",
        category_id: 0,
      },
      {
        id: 34,
        parent_id: 32,
        sort: 2,
        name: "real_estate_agencies",
        display_name: "地產中介",
        category_id: 0,
      },
      {
        id: 129,
        parent_id: 32,
        sort: 3,
        name: "title",
        display_name: "產權公司",
        category_id: 0,
      },
      {
        id: 149,
        parent_id: 32,
        sort: 4,
        name: "property_tax",
        display_name: "房产减税",
        category_id: 0,
      },
      {
        id: 130,
        parent_id: 32,
        sort: 5,
        name: "builder",
        display_name: "建築營造",
        category_id: 0,
      },
      {
        id: 131,
        parent_id: 32,
        sort: 6,
        name: "building_material",
        display_name: "建材公司",
        category_id: 0,
      },
      {
        id: 35,
        parent_id: 32,
        sort: 7,
        name: "house_inspections",
        display_name: "房屋檢查",
        category_id: 0,
      },
      {
        id: 133,
        parent_id: 32,
        sort: 8,
        name: "house_improvement",
        display_name: "房屋裝修",
        category_id: 0,
      },
      {
        id: 134,
        parent_id: 32,
        sort: 9,
        name: "roofing_n_door",
        display_name: "屋頂門窗",
        category_id: 0,
      },
      {
        id: 135,
        parent_id: 32,
        sort: 10,
        name: "plumbing_n_electrician",
        display_name: "水電水管",
        category_id: 0,
      },
      {
        id: 136,
        parent_id: 32,
        sort: 11,
        name: "ac",
        display_name: "冷氣暖氣",
        category_id: 0,
      },
      {
        id: 37,
        parent_id: 32,
        sort: 12,
        name: "kitchen_n_bath",
        display_name: "廚廁設備",
        category_id: 0,
      },
      {
        id: 142,
        parent_id: 32,
        sort: 13,
        name: "yard",
        display_name: "庭院美化",
        category_id: 0,
      },
      {
        id: 144,
        parent_id: 32,
        sort: 14,
        name: "ironworks",
        display_name: "鐵工廠",
        category_id: 0,
      },
    ],
  },
  {
    id: 38,
    parent_id: 10,
    sort: 5,
    name: "financial services",
    display_name: "理財保險",
    category_id: 0,
    sub_categories: [
      {
        id: 41,
        parent_id: 38,
        sort: 1,
        name: "banks",
        display_name: "銀行",
        category_id: 0,
      },
      {
        id: 124,
        parent_id: 38,
        sort: 2,
        name: "insurance_companies",
        display_name: "保險公司",
        sub_categories: [],
      },
      {
        id: 39,
        parent_id: 38,
        sort: 3,
        name: "accounting",
        display_name: "會計",
        category_id: 0,
      },
      {
        id: 40,
        parent_id: 38,
        sort: 4,
        name: "investments",
        display_name: "財經服務",
        category_id: 0,
      },
      {
        id: 42,
        parent_id: 38,
        sort: 5,
        name: "loan",
        display_name: "貸款公司",
        category_id: 0,
      },
      {
        id: 150,
        parent_id: 38,
        sort: 6,
        name: "asset_management",
        display_name: "資產管理",
        category_id: 0,
      },
    ],
  },
  {
    id: 43,
    parent_id: 10,
    sort: 6,
    name: "cultural_organizations",
    display_name: "文化組織",
    category_id: 0,
    sub_categories: [
      {
        id: 47,
        parent_id: 43,
        sort: 1,
        name: "religions",
        display_name: "教會佛寺",
        category_id: 0,
      },
      {
        id: 48,
        parent_id: 43,
        sort: 2,
        name: "others_cultural",
        display_name: "活動中心",
        category_id: 0,
      },
      {
        id: 44,
        parent_id: 43,
        sort: 3,
        name: "natives_associations",
        display_name: "同鄉會",
        category_id: 0,
      },
      {
        id: 45,
        parent_id: 43,
        sort: 4,
        name: "oversea_chinese_communities",
        display_name: "華人社區",
        category_id: 0,
      },
      {
        id: 46,
        parent_id: 43,
        sort: 5,
        name: "school_associations",
        display_name: "學聯校友",
        category_id: 0,
      },
      {
        id: 146,
        parent_id: 43,
        sort: 6,
        name: "service_center",
        display_name: "服務中心",
        category_id: 0,
      },
      {
        id: 145,
        parent_id: 43,
        sort: 7,
        name: "elderly_care",
        display_name: "老人中心",
        category_id: 0,
      },
    ],
  },
  {
    id: 49,
    parent_id: 10,
    sort: 7,
    name: "food",
    display_name: "餐飲",
    category_id: 0,
    sub_categories: [
      {
        id: 50,
        parent_id: 49,
        sort: 1,
        name: "chinese",
        display_name: "中餐",
        category_id: 0,
      },
      {
        id: 51,
        parent_id: 49,
        sort: 2,
        name: "japanese",
        display_name: "日料",
        category_id: 0,
      },
      {
        id: 52,
        parent_id: 49,
        sort: 3,
        name: "korean",
        display_name: "韓式",
        category_id: 0,
      },
      {
        id: 53,
        parent_id: 49,
        sort: 4,
        name: "mexican",
        display_name: "墨西哥",
        category_id: 0,
      },
      {
        id: 54,
        parent_id: 49,
        sort: 5,
        name: "american",
        display_name: "美式",
        category_id: 0,
      },
      {
        id: 55,
        parent_id: 49,
        sort: 6,
        name: "bakery",
        display_name: "西點麵包",
        category_id: 0,
      },
      {
        id: 138,
        parent_id: 49,
        sort: 7,
        name: "wholesale",
        display_name: "食品批發",
        category_id: 0,
      },
      {
        id: 56,
        parent_id: 49,
        sort: 8,
        name: "restaurant_service",
        display_name: "餐飲設備",
        category_id: 0,
      },
      {
        id: 57,
        parent_id: 49,
        sort: 9,
        name: "pos",
        display_name: "餐飲系統",
        category_id: 0,
      },
    ],
  },
  {
    id: 58,
    parent_id: 10,
    sort: 8,
    name: "health",
    display_name: "醫療健康",
    category_id: 0,
    sub_categories: [
      {
        id: 59,
        parent_id: 58,
        sort: 1,
        name: "massages",
        display_name: "按摩",
        category_id: 0,
      },
      {
        id: 60,
        parent_id: 58,
        sort: 2,
        name: "pharmacies",
        display_name: "藥房",
        category_id: 0,
      },
      {
        id: 70,
        parent_id: 58,
        sort: 3,
        name: "chinese_medicine",
        display_name: "中醫/針灸",
        category_id: 0,
      },
      {
        id: 61,
        parent_id: 58,
        sort: 4,
        name: "dentists",
        display_name: "牙醫",
        category_id: 0,
      },
      {
        id: 62,
        parent_id: 58,
        sort: 5,
        name: "family",
        display_name: "家庭全科",
        category_id: 0,
      },
      {
        id: 63,
        parent_id: 58,
        sort: 6,
        name: "plastic_surgeries",
        display_name: "整形",
        category_id: 0,
      },
      {
        id: 64,
        parent_id: 58,
        sort: 7,
        name: "pediatrics",
        display_name: "小兒科",
        category_id: 0,
      },
      {
        id: 65,
        parent_id: 58,
        sort: 8,
        name: "ent",
        display_name: "五官科",
        category_id: 0,
      },
      {
        id: 66,
        parent_id: 58,
        sort: 9,
        name: "internal",
        display_name: "內科",
        category_id: 0,
      },
      {
        id: 160,
        parent_id: 58,
        sort: 10,
        name: "internal_",
        display_name: "腸胃/內臟",
        category_id: 0,
      },
      {
        id: 67,
        parent_id: 58,
        sort: 11,
        name: "gynecology",
        display_name: "婦產科",
        category_id: 0,
      },
      {
        id: 68,
        parent_id: 58,
        sort: 12,
        name: "orthotics",
        display_name: "足科骨科",
        category_id: 0,
      },
      {
        id: 69,
        parent_id: 58,
        sort: 13,
        name: "dermatology",
        display_name: "皮膚科",
        category_id: 0,
      },
      {
        id: 71,
        parent_id: 58,
        sort: 14,
        name: "recovery",
        display_name: "疼痛復健",
        category_id: 0,
      },

      {
        id: 153,
        parent_id: 58,
        sort: 15,
        name: "mental_health",
        display_name: "心理咨询",
        category_id: 0,
      },
      {
        id: 72,
        parent_id: 58,
        sort: 16,
        name: "others_health",
        display_name: "護理中心",
        category_id: 0,
      },
    ],
  },
  {
    id: 73,
    parent_id: 10,
    sort: 9,
    name: "outdoors",
    display_name: "行車運輸",
    category_id: 0,
    sub_categories: [
      {
        id: 75,
        parent_id: 73,
        sort: 1,
        name: "auto_repair",
        display_name: "修車廠",
        category_id: 0,
      },
      {
        id: 74,
        parent_id: 73,
        sort: 2,
        name: "auto_dealerships",
        display_name: "車行",
        category_id: 0,
      },
      {
        id: 154,
        parent_id: 73,
        sort: 3,
        name: "auto_tint",
        display_name: "车窗贴膜",
        category_id: 0,
      },
      {
        id: 76,
        parent_id: 73,
        sort: 4,
        name: "drivers license",
        display_name: "駕照培訓",
        category_id: 0,
      },
      {
        id: 77,
        parent_id: 73,
        sort: 5,
        name: "travel_agencies",
        display_name: "旅行社",
        category_id: 0,
      },
      {
        id: 78,
        parent_id: 73,
        sort: 6,
        name: "moving",
        display_name: "搬家公司",
        category_id: 0,
      },
      {
        id: 147,
        parent_id: 73,
        sort: 7,
        name: "transportation",
        display_name: "運輸公司",
        category_id: 0,
      },
      {
        id: 80,
        parent_id: 73,
        sort: 8,
        name: "others_outdoors",
        display_name: "其他",
        category_id: 0,
      },
    ],
  },
  {
    id: 81,
    parent_id: 10,
    sort: 10,
    name: "education",
    display_name: "教育學術",
    category_id: 0,
    sub_categories: [
      {
        id: 82,
        parent_id: 81,
        sort: 1,
        name: "schools",
        display_name: "學校",
        category_id: 0,
      },
      {
        id: 83,
        parent_id: 81,
        sort: 2,
        name: "chineses_school",
        display_name: "中文學校",
        category_id: 0,
      },
      {
        id: 139,
        parent_id: 81,
        sort: 3,
        name: "martial_art",
        display_name: "武術學校",
        category_id: 0,
      },
      {
        id: 155,
        parent_id: 81,
        sort: 4,
        name: "beauty",
        display_name: "美容學校",
        category_id: 0,
      },
      {
        id: 161,
        parent_id: 81,
        sort: 5,
        name: "gym",
        display_name: "健身/瑜珈",
        category_id: 0,
      },
      {
        id: 84,
        parent_id: 81,
        sort: 6,
        name: "training_institution",
        display_name: "培訓機構",
        category_id: 0,
      },
      {
        id: 85,
        parent_id: 81,
        sort: 7,
        name: "others_edu",
        display_name: "其他",
        category_id: 0,
      },
    ],
  },
  {
    id: 11,
    parent_id: 10,
    sort: 11,
    name: "entertainment",
    display_name: "娛樂",
    category_id: 0,
    sub_categories: [
      {
        id: 127,
        parent_id: 11,
        sort: 1,
        name: "feng_shui",
        display_name: "風水命理",
        category_id: 0,
      },
      {
        id: 12,
        parent_id: 11,
        sort: 2,
        name: "casino",
        display_name: "賭場",
        category_id: 0,
      },
      {
        id: 14,
        parent_id: 11,
        sort: 3,
        name: "hotel",
        display_name: "酒店旅館",
        category_id: 0,
      },
      {
        id: 15,
        parent_id: 11,
        sort: 4,
        name: "gun_shop",
        display_name: "槍店",
        category_id: 0,
      },
      {
        id: 126,
        parent_id: 11,
        sort: 5,
        name: "florist",
        display_name: "花店",
        category_id: 0,
      },
      {
        id: 16,
        parent_id: 11,
        sort: 6,
        name: "art_gallery",
        display_name: "藝術畫廊",
        category_id: 0,
      },
      {
        id: 125,
        parent_id: 11,
        sort: 7,
        name: "multi_media",
        display_name: "影音設備",
        category_id: 0,
      },
      {
        id: 151,
        parent_id: 11,
        sort: 8,
        name: "antique",
        display_name: "玉器古玩",
        category_id: 0,
      },
      {
        id: 17,
        parent_id: 11,
        sort: 9,
        name: "others_entertainment",
        display_name: "其他",
        category_id: 0,
      },
    ],
  },
];
